export default "__VITE_ASSET__CTYnDO_e__"